module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./EditVideoView.js"));
	}, "EditVideoView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EditVideoView!./src/pages/Promote/BusinessCard/EditVideo/EditVideoView.js
// module id = 1107
// module chunks = 438